import { Link, useRouterState } from "@tanstack/react-router";
import { useLocale } from "@/i18n/locale-context";

const LABELS = {
  fr: { label: "Remarque", title: "Envoyer une remarque, suggestion ou signaler un problème" },
  en: { label: "Feedback", title: "Send a remark, suggestion or report an issue" },
  nl: { label: "Feedback", title: "Stuur een opmerking, suggestie of meld een probleem" },
} as const;

export function FeedbackFab() {
  const { locale } = useLocale();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (pathname.startsWith("/faq")) return null;
  if (pathname.startsWith("/login") || pathname.startsWith("/checkout")) return null;
  const L = LABELS[locale as keyof typeof LABELS] ?? LABELS.fr;
  return (
    <Link
      to="/faq"
      hash="feedback"
      aria-label={L.title}
      title={L.title}
      className="fixed z-40 bottom-4 right-4 md:bottom-6 md:right-6 inline-flex items-center gap-2 rounded-full bg-foreground text-background shadow-lg hover:opacity-90 transition-opacity px-4 py-3 text-sm font-medium pb-[max(0.75rem,env(safe-area-inset-bottom))]"
    >
      <span aria-hidden>💬</span>
      <span className="hidden sm:inline">{L.label}</span>
    </Link>
  );
}